import { render } from "./CreaArticoloModal.vue?vue&type=template&id=59624968"
import script from "./CreaArticoloModal.vue?vue&type=script&lang=js"
export * from "./CreaArticoloModal.vue?vue&type=script&lang=js"

import "./CreaArticoloModal.vue?vue&type=style&index=0&id=59624968&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__